import {
  gridSizeMdLg12,
  texto,
  gridSizeMdLg6,
  gridSize,
  gridSizeConst10,
  gridSizeConst1,
  gridSizeConst2,
  TIPO_REFERIDO_PREVENTA_CHOICE,
  TipoReferidoEnumChoice,
  gridSizeConst6,
  CUOTAS_CHOICE,
  CANTIDAD_CHOICE,
} from "@/shared";
import {
  TabTextLabel,
  CustomAutocomplete,
  CustomTextField,
  CustomAutocompleteArrString,
  CustomTextFieldNumberComponente,
  CustomTextArea,
  SingleButton,
  CustomAutocompleteArrStringNoForm,
} from "@/shared/components/ui";
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
import {
  Cliente,
  Flota,
  IDataProspecto,
  IEquipoServicioAdicionales,
  IFormPreventa,
  TipoVentaEnum,
} from "@/shared/interfaces";
import { Delete, Visibility } from "@mui/icons-material";
import { Alert, Grid, IconButton, Typography } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { ApiResponse } from "@/shared/interfaces/erp/global/response-axios.interface";
// import ModalCuotas from "../modal_cuotas/ModalCuotas"
// import { useEquiposAdicionales } from "@/store/erp"
// import { TooltipIconEdit } from "../SavePreventa"
import ModalEquiposAdicionalesVenta from "@/erp/inventario/ingreso-producto/shared/componente/ModalEquiposAdicionalesVenta";
import ModalServicioAdicionalesVenta from "@/erp/inventario/ingreso-producto/shared/componente/ModalServicioAdicionalesVenta";
import { TooltipIconEdit } from "@/erp/sale";
import ModalCuotas from "@/erp/sale/asesor/preventa/shared/component/modal_cuotas/ModalCuotas";
import { Empleado } from "@/shared/interfaces/erp/empleados";
import CustomAutocompleteFetchForm from "@/shared/components/ui/CustomAutocompleteFetchForm";
import { getEmpleados } from "@/shared/actions/erp/empleados";
import { useMemo } from "react";
import { useAuthStore } from "@/store/auth";

interface TabOtrosCargosPreventaProps {
  dataProspecto: IDataProspecto;
  editSupervisor: boolean;
  form: UseFormReturn<IFormPreventa, any, IFormPreventa>;
  visibleReferido: boolean;
  setVisibleReferido: React.Dispatch<React.SetStateAction<boolean>>;
  handleBuscarReferido: (identificacion: string) => Promise<void>;
  esReferido: number;
  isPendingReferido: boolean;
  setEsReferido: React.Dispatch<React.SetStateAction<number>>;
  dataReferido: ApiResponse<Cliente> | undefined;
  dataFlota: Flota[] | undefined;
  isLoadingFlota: boolean;
  getDataProducto: (data: IEquipoServicioAdicionales | undefined) => void;
  productos: IEquipoServicioAdicionales[];
  handleAgregarProducto: (producto: IEquipoServicioAdicionales) => void;
  handleEliminarProducto: (id: string) => void;
  fetchAutocompleteEmpleado: any;
  handleActualizarProducto: (
    id: string,
    nuevosValores: Partial<IEquipoServicioAdicionales>,
  ) => void;
}

// 1. Constantes fuera del componente para evitar recrearlas en cada render
const OPCIONES_DIGITALES: TipoReferidoEnumChoice[] = [
  TipoReferidoEnumChoice.CLIENTE,
  TipoReferidoEnumChoice.FLOTA,
  TipoReferidoEnumChoice.EMPLEADO,
];

const OPCIONES_GENERALES: TipoReferidoEnumChoice[] = [
  TipoReferidoEnumChoice.CLIENTE,
  TipoReferidoEnumChoice.FLOTA,
];

const CANAL_DIGITAL = "VENT-DIGI-01";

export default function TabOtrosCargosPreventa({
  editSupervisor,
  visibleReferido,
  setVisibleReferido,
  form,
  handleBuscarReferido,
  esReferido,
  setEsReferido,
  isLoadingFlota,
  dataFlota,
  getDataProducto,
  productos,
  handleActualizarProducto,
  handleAgregarProducto,
  handleEliminarProducto,
  fetchAutocompleteEmpleado,
  dataProspecto,
}: TabOtrosCargosPreventaProps) {
  const auth = useAuthStore((s) => s.user);

  const tieneBeneficio = [
    dataProspecto.es_tercera_edad,
    dataProspecto.es_discapacitado,
    dataProspecto.es_curador_tutor,
    dataProspecto.es_ayuda_social,
    dataProspecto.es_bono_humano,
    dataProspecto.es_gremio,
  ].some(Boolean);

  const empleadoAreaParams = useMemo(
    () => ({
      area_corporativa_mix: "COM-01",
    }),
    [],
  );

  const referidoOpciones = useMemo(() => {
    const tieneCanalDigital =
      auth?.canales?.includes(CANAL_DIGITAL) ||
      auth?.canales_venta_adicionales?.includes(CANAL_DIGITAL);

    return tieneCanalDigital ? OPCIONES_DIGITALES : OPCIONES_GENERALES;
  }, [auth?.canales, auth?.canales_venta_adicionales]);

  const {
    control,
    reset,
    formState: { errors },
  } = form;

  return (
    <>
      <Grid container spacing={3}>
        <Grid
          item
          container
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          {...gridSize}
        >
          <Grid item>
            <TabTextLabel
              text={texto.persona_referido}
              mt={0}
              pb={0}
              pl={0}
              pt={2}
            />
          </Grid>

          <Grid item>
            <SingleButton
              color={visibleReferido ? "error" : "primary"}
              variant="outlined"
              label={visibleReferido ? "Eliminar" : "Agregar"}
              startIcon={visibleReferido ? <DeleteIcon /> : <AddIcon />}
              onClick={() => {
                setVisibleReferido(!visibleReferido);

                reset({
                  ...form.getValues(),
                  tipo_referido: "",
                  codigo_refiere: null,
                  cedula_refiere: "",
                  referido_cliente: "",
                  celular_refiere: "",
                  direccion_refiere: "",
                  plan_referido: "",
                  referido_flota: "",
                  nombre_refiere: "",
                  referido_empleado: "",
                });
              }}
            />
          </Grid>

          {editSupervisor && <TooltipIconEdit />}
        </Grid>

        {visibleReferido && (
          <CustomAutocompleteArrString
            label={texto.tipo_referido}
            name="tipo_referido"
            options={referidoOpciones}
            control={form.control}
            defaultValue={form.getValues().tipo_referido ?? ""}
            error={errors.tipo_referido}
            helperText={errors.tipo_referido?.message?.toString() ?? ""}
            isLoadingData={false}
            size={gridSizeMdLg6}
            onChangeValue={(e) => {
              setEsReferido(404);
              reset({
                ...form.getValues(),
                tipo_referido: e,
                nombre_refiere: null,
                cedula_refiere: null,
                celular_refiere: null,
                direccion_refiere: null,
                referido_flota: null,
                codigo_refiere: null,
              });
            }}
          />
        )}

        {form.getValues().tipo_referido == TipoReferidoEnumChoice.CLIENTE && (
          <Grid
            item
            container
            {...gridSizeMdLg6}
            justifyItems={"center"}
            alignItems={"center"}
            alignContent={"center"}
          >
            <CustomTextFieldNumberComponente
              size={gridSizeConst10}
              max={13}
              type={TiposTextFieldNumberEnum.IDENTIFICACION}
              label={texto.cedula_refiere}
              error={errors.cedula_refiere}
              helperText={errors.cedula_refiere?.message}
              control={control}
              name="cedula_refiere"
              defaultValue={form.getValues().cedula_refiere ?? ""}
              onChangeValue={(identificacion) => {
                handleBuscarReferido(identificacion);
              }}
            />
            <Grid item {...gridSizeConst2} alignItems={"end"}>
              <IconButton
                onClick={(_e: any) => {
                  handleBuscarReferido(form.getValues().cedula_refiere ?? "");
                }}
                size="small"
              >
                <SearchIcon />
              </IconButton>
            </Grid>
          </Grid>
        )}

        {esReferido == 200 && (
          <>
            <CustomTextField
              control={control}
              name={"nombre_refiere"}
              defaultValue={form.getValues().nombre_refiere}
              size={gridSizeMdLg6}
              label={texto.cliente_refiere}
              error={errors.nombre_refiere}
              helperText={errors.nombre_refiere?.message}
            />

            <CustomTextFieldNumberComponente
              size={gridSizeMdLg6}
              type={TiposTextFieldNumberEnum.CELULAR}
              label={texto.telefono_cliente_refiere}
              name={"celular_refiere"}
              control={control}
              defaultValue={form.getValues().cedula_refiere}
              error={errors.celular_refiere}
              helperText={errors.celular_refiere?.message}
            />

            <CustomTextField
              control={control}
              label={texto.direccion_cliente_refiere}
              name="direccion_refiere"
              defaultValue={form.getValues().direccion_refiere}
              size={gridSizeMdLg12}
              error={errors.direccion_refiere}
              helperText={errors.direccion_refiere?.message}
            />

            <Grid item {...gridSizeMdLg12}>
              <Alert variant="outlined" severity="success">
                ¡Referido encontrado! Por favor, verifica la información.
              </Alert>
            </Grid>
          </>
        )}

        {form.getValues().tipo_referido == TipoReferidoEnumChoice.FLOTA && (
          <CustomAutocomplete<Flota>
            size={gridSizeMdLg6}
            label="Flota"
            name="referido_flota"
            options={dataFlota || []}
            valueKey="nombre"
            actualValueKey="codigo"
            defaultValue={form.getValues().referido_flota ?? ""}
            isLoadingData={isLoadingFlota}
            control={control}
            error={errors.referido_flota}
            helperText={errors.referido_flota?.message}
          />
        )}

        {form.getValues().tipo_referido == TipoReferidoEnumChoice.EMPLEADO &&
          !tieneBeneficio && (
            <CustomAutocompleteFetchForm<Empleado>
              required={false}
              size={gridSizeMdLg6}
              control={control}
              name="referido_empleado"
              label="Empleado"
              fetchParams={empleadoAreaParams}
              getOptionLabel={(opt) => `${opt.razon_social}` || ""}
              key={"autocomplete-empleado"}
              getOptionKey={(opt) => opt.codigo}
              initialInputValue={form.getValues().referido_empleado ?? ""}
              onChangeValue={(e: any) => {
                reset({
                  ...form.getValues(),
                  referido_empleado: e ?? null,
                });
              }}
              ///* fetch
              keySearch="razon_social"
              isAll
              fetchData={fetchAutocompleteEmpleado}
              loadOptionByValue={async (cod) => {
                const resp = await getEmpleados({
                  codigo: cod as string,
                });

                return resp.data.data[0] ?? null;
              }}
            />
          )}

        {form.getValues().tipo_referido == TipoReferidoEnumChoice.EMPLEADO &&
          tieneBeneficio && (
            <Grid item>
              <Alert severity="info">
                Este prospecto tiene beneficios (AYUDA SOCIAL, TERCERA EDAD,
                DISCAPACIDAD, etc) por lo que no cumple con las políticas
                comerciales vigentes para ser referido por un EMPLEADO.
              </Alert>
            </Grid>
          )}
        {/* equipos adicionales */}
        <Grid
          item
          container
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          {...gridSizeMdLg12}
        >
          <Grid item>
            <TabTextLabel
              text={"Equipos de Venta"}
              mt={0}
              pb={0}
              pl={0}
              pt={2}
            />
          </Grid>

          <Grid item>
            <ModalEquiposAdicionalesVenta
              textButton="Agregar"
              onChange={(e) => {
                const nuevoProducto: IEquipoServicioAdicionales = {
                  id: e.id_producto,
                  codigo: e.codigo,
                  cantidad: "1",
                  cuotas: "1",
                  tipoVenta: TipoVentaEnum.EQUIPO,
                  precios: e.precios,
                  descripcion: e.descripcion,
                };

                handleAgregarProducto(nuevoProducto);
              }}
            />
          </Grid>
        </Grid>

        <Grid
          item
          container
          spacing={3}
          justifyContent={"space-between"}
          {...gridSizeMdLg12}
        >
          {productos
            .filter((e) => e.tipoVenta == TipoVentaEnum.EQUIPO)
            .map((element) => {
              return (
                <Grid
                  item
                  container
                  spacing={1}
                  {...gridSizeMdLg12}
                  key={element.codigo}
                >
                  <Grid item {...gridSizeConst6}>
                    <Typography variant="subtitle2">
                      {element.descripcion}
                    </Typography>
                  </Grid>

                  <CustomAutocompleteArrStringNoForm
                    label="Cant."
                    options={CANTIDAD_CHOICE}
                    size={gridSizeConst2}
                    defaultValue={element.cantidad ?? "1"}
                    onChangeValue={(value) => {
                      handleActualizarProducto(element.id!, {
                        cantidad: value,
                      });
                    }}
                  />

                  <CustomAutocompleteArrStringNoForm
                    label="Cuotas"
                    options={CUOTAS_CHOICE}
                    size={gridSizeConst2}
                    defaultValue={element.cuotas ?? "1"}
                    onChangeValue={(value) => {
                      handleActualizarProducto(element.id!, { cuotas: value });
                    }}
                  />

                  <Grid item {...gridSizeConst1}>
                    <IconButton
                      onClick={() => {
                        const findProducto = productos.find(
                          (e) => e.id == element.id!,
                        );
                        getDataProducto(findProducto);
                      }}
                    >
                      <Visibility />
                    </IconButton>
                  </Grid>

                  <Grid item {...gridSizeConst1}>
                    <IconButton
                      onClick={() => {
                        handleEliminarProducto(element.id!);
                      }}
                    >
                      <Delete />
                    </IconButton>
                  </Grid>
                </Grid>
              );
            })}
        </Grid>

        {/* servicios adicionales */}
        <Grid
          item
          container
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          {...gridSizeMdLg12}
        >
          <Grid item>
            <TabTextLabel text={"Servicios"} mt={0} pb={0} pl={0} pt={2} />
          </Grid>

          <Grid item>
            <ModalServicioAdicionalesVenta
              textButton="Agregar"
              onChange={(e) => {
                const nuevoProducto: IEquipoServicioAdicionales = {
                  id: e.id_servicio,
                  codigo: e.codigo,
                  cantidad: "1",
                  cuotas: "1",
                  tipoVenta: TipoVentaEnum.SERVICIO,
                  precios: [{ estado: true, nombre: "precio 1", precio: "0" }],
                  descripcion: e.descripcion,
                };

                handleAgregarProducto(nuevoProducto);
              }}
            />
          </Grid>
        </Grid>

        {productos
          .filter((e) => e.tipoVenta == TipoVentaEnum.SERVICIO)
          .map((element) => {
            return (
              <Grid
                item
                container
                spacing={1}
                {...gridSizeMdLg12}
                key={element.codigo}
              >
                <Grid item {...gridSizeConst6}>
                  <Typography variant="subtitle2">
                    {element.descripcion}
                  </Typography>
                </Grid>

                <CustomAutocompleteArrStringNoForm
                  label="Cant."
                  options={CANTIDAD_CHOICE}
                  size={gridSizeConst2}
                  defaultValue={element.cantidad ?? "1"}
                  onChangeValue={(value) => {
                    handleActualizarProducto(element.id!, { cantidad: value });
                  }}
                />

                <CustomAutocompleteArrStringNoForm
                  label="Cuotas"
                  options={CUOTAS_CHOICE}
                  size={gridSizeConst2}
                  defaultValue={element.cuotas ?? "1"}
                  onChangeValue={(value) => {
                    handleActualizarProducto(element.id!, { cuotas: value });
                  }}
                />

                <Grid item {...gridSizeConst1}>
                  <IconButton
                    onClick={() => {
                      const findProducto = productos.find(
                        (e) => e.id == element.id!,
                      );
                      getDataProducto(findProducto);
                    }}
                  >
                    <Visibility />
                  </IconButton>
                </Grid>

                <Grid item {...gridSizeConst1}>
                  <IconButton
                    onClick={() => {
                      handleEliminarProducto(element.id!);
                    }}
                  >
                    <Delete />
                  </IconButton>
                </Grid>

                {/* <Grid item xs={12}>
                    <div className="linea"></div>

                  </Grid> */}
              </Grid>
            );
          })}

        <Grid item xs={12}>
          <TabTextLabel text={texto.observacion} mt={0} pb={0} pl={0} pt={2} />
        </Grid>

        <CustomTextArea
          disabled={editSupervisor}
          label={"Observación 1"}
          name="observacion_1"
          control={form.control}
          defaultValue={form.getValues().observacion_1}
          error={errors.observacion_1}
          helperText={errors.observacion_1?.message}
          required={false}
          rows={3}
        />

        <CustomTextArea
          disabled={editSupervisor}
          label={"Observación 2"}
          name="observacion_2"
          control={form.control}
          defaultValue={form.getValues().observacion_2}
          error={errors.observacion_2}
          helperText={errors.observacion_2?.message}
          required={false}
          rows={3}
        />
      </Grid>

      <ModalCuotas />
    </>
  );
}
